import React from "react";
import EmptyImage from "../../../../../../assets/default_img.png";
import { SingleBorderCard } from "../../../../../common/SingleBorderCard";

const RewardCard = ({ reward, isSelected, rewardUnitAndTypeMaps }) => {
  const { unitsMap = {}, typesMap = {} } = rewardUnitAndTypeMaps || {};
  const unitStr = unitsMap[reward.rewardUnitId];
  let unitType = "-";

  if (unitStr) {
    if (unitStr === "points") {
      unitType = "points";
    } else {
      unitType = typesMap[reward.rewardTypeId] || unitStr || "-";
    }
  }
  return (
    <SingleBorderCard>
      <img
        src={reward.imageUrl || EmptyImage}
        height={200}
        style={{
          borderRadius: "6px",
          objectFit: "cover",
          width: "100%",
        }}
        alt={reward.name}
        onError={(e) => {
          e.target.onerror = null; // Prevent infinite loop
          e.target.src = EmptyImage; // Fallback image
        }}
      />
      <h4
        className="font-sm text-wrap text-ellipsis-2"
        style={{ minHeight: "24px" }}
        title={reward.name}
        data-testid={`reward-name-${reward.id}`}
      >
        {reward.name}
      </h4>
      <p
        className="font-sm text-wrap text-ellipsis-2"
        style={{ minHeight: "24px", color: "#616161" }}
        title={reward.shortDescription}
      >
        {reward.shortDescription}
      </p>
      <p
        className="font-sm"
        style={{ color: "#424242", marginTop: "4px", fontWeight: "500" }}
      >
        Type: {unitType}
      </p>
      {isSelected && (
        <img
          src={"/assets/images/checkmark.png"}
          height={24}
          width={24}
          style={{ position: "absolute", right: 10, top: 10 }}
          alt="Selected"
        />
      )}
    </SingleBorderCard>
  );
};

export default React.memo(RewardCard);
